// extracted by mini-css-extract-plugin
module.exports = {"bestOffer":"best_offer_bestOffer__3g1VI"};